<script lang="ts">
	import { handleStoreError } from '../../stores/GeneralStore';

	interface Props {
		id?: string | null;
		dataTestId?: string | null;
		checked: boolean | undefined;
		propertyName: string;
		config?: { topText: string; bottomText: string } | null;
		tabSwitcher?: boolean;
		positionDesign?: boolean;
		callFunction?: ((object: any) => Promise<any>) | null;
		disabled?: boolean;
		onCheckChanged?: (checked: boolean) => void;
	}

	let {
		id = null,
		dataTestId = null,
		checked = $bindable(),
		propertyName,
		config = null,
		tabSwitcher = false,
		positionDesign = false,
		callFunction = null,
		disabled = false,
		onCheckChanged = undefined
	}: Props = $props();

	async function handleCheckChanged() {
		if (callFunction) {
			//Set the new state
			checked = !checked;

			try {
				const dynamicObject: any = {};
				dynamicObject[propertyName] = checked;

				await callFunction(dynamicObject);
			} catch (error) {
				//Check if we have an error type
				handleStoreError('general.patch_failed', error);

				//Invert it again
				checked = !checked;
			}
		} else {
			checked = !checked;
			onCheckChanged?.(checked);		
		}
	}
</script>

{#if config}
	<button
		{id}
		data-testid={dataTestId || propertyName}
		class="bg-white dark:bg-dark-200 rounded-lg grid"
		class:switcher={tabSwitcher}
		{disabled}
		onclick={handleCheckChanged}
	>
		<p
			class="rounded-xl border-2 px-2 cursor-pointer text-center {checked
				? 'border-primary-200 dark:border-secondary-500 text-primary-200 dark:text-white bg-background dark:bg-secondary-500 shadow-md'
				: 'border-transparent dark:text-white'} text-center"
		>
			{config.topText}
		</p>
		<p
			class="rounded-xl border-2 px-2 cursor-pointer text-center {!checked
				? 'border-primary-200 dark:border-secondary-500 text-primary-200 dark:text-white bg-background dark:bg-secondary-500 shadow-md'
				: 'border-transparent dark:text-white'} text-center"
		>
			{config.bottomText}
		</p>
	</button>
{:else}
	<div class:positionDesign class="flex items-center py-2">
		<!-- svelte-ignore a11y_consider_explicit_label -->
		<button
			{id}
			data-testid={dataTestId || propertyName}
			class:switcher={tabSwitcher}
			{disabled}
			class:checked
			class="slider-tray rounded-xl border-2"
			onclick={handleCheckChanged}
		>
			<div
				class="bg-white slider border-disabled border-gray shadow-lg"
				class:slider-active={checked}
			></div>
		</button>
	</div>
{/if}

<style>
	.slider-tray :global {
		width: 45px;
		height: 25px;
		--tw-border-opacity: 1;
		border-color: rgb(227 227 227 / var(--tw-border-opacity, 1));
		--tw-bg-opacity: 1;
		background-color: rgb(227 227 227 / var(--tw-bg-opacity, 1));
	}
	.slider-tray :global:where(.dark, .dark *) {
		--tw-border-opacity: 1;
		border-color: rgb(56 56 56 / var(--tw-border-opacity, 1));
		--tw-bg-opacity: 1;
		background-color: rgb(78 78 78 / var(--tw-bg-opacity, 1));
}

	.slider-tray.checked :global {
		--tw-border-opacity: 1;
		border-color: rgb(23 137 192 / var(--tw-border-opacity, 1));
		--tw-bg-opacity: 1;
		background-color: rgb(23 137 192 / var(--tw-bg-opacity, 1));
}

	.slider-tray.checked :global:where(.dark, .dark *) {
		--tw-border-opacity: 1;
		border-color: rgb(146 188 220 / var(--tw-border-opacity, 1));
		--tw-bg-opacity: 1;
		background-color: rgb(146 188 220 / var(--tw-bg-opacity, 1));
}

	.slider-tray:focus {
		outline-color: #2ddaff;
}

	.positionDesign {
		border-width: 0px 2px;
		height: 100%;
	}

	.positionDesign:hover {
		--tw-border-opacity: 1;
		border-color: rgb(45 218 255 / var(--tw-border-opacity, 1));
}

	.slider {
		border-width: 1px;
		border-radius: 50%;
		transition: 0.4s;
		height: 20px;
		width: 20px;
	}

	.slider-active {
		transform: translateX(20px);
	}
</style>
